/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Modal,
  Warning,
  CasesCountAndCreate,
  Cases
} from '../'

import {
  decodeBase64
} from '../../utils'

export class ToolbarIdentityCases extends React.Component {
  static propTypes = {
    identityId: PropTypes.string.isRequired,
    elementId: PropTypes.string,
    onCaseCreateClick: PropTypes.func.isRequired,
    forwardedRef: PropTypes.object
  }

  state = {
    viewCaseDetailsTimestamp: null
  }

  handleCaseViewClick = () => this.setState({ viewCaseDetailsTimestamp: Math.floor(Date.now() / 1000) })  // get unix timestamp in seconds

  render() {
    let { identityId, elementId, onCaseCreateClick, forwardedRef } = this.props

    return (
      <Query
        query={
          gql`
            query($id: UUID!) {
              cases(affects_Id: $id) {
                edges {
                  node {
                    id
                    priority
                    productType
                    requestType
                    createdAt
                    status
                    nextActionAt
                  }
                }
              }
            }
          `
        }
        variables={{ id: decodeBase64(identityId) }}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return <Spinner className='slds-is-relative slds-m-left_large' size='x-small' />
          }
          if (error) {
            return (
              <Warning className='slds-m-left_small' iconSize='x-small'>
                Failed to load case information.
              </Warning>
            )
          }

          let openCases = data.cases.edges.filter(({ node: caseRecord }) => (
            caseRecord.status === 'OPEN'
          ))
          let resolvedCases = data.cases.edges.filter(({ node: caseRecord }) => (
            caseRecord.status === 'RESOLVED'
          ))

          return (
            <CasesCountAndCreate
              ref={forwardedRef}
              numberOfOpenCases={openCases.length}
              numberOfResolvedCases={resolvedCases.length}
              onCaseCreateClick={onCaseCreateClick}
              openCasesRender={ref =>
                <Modal
                  ref={ref}
                  heading='Open cases'
                  body={
                    <CasesWrapper
                      identityId={identityId}
                      status='open'
                      onCaseViewClick={this.handleCaseViewClick}
                    />
                  }
                  elementId={elementId}
                />
              }
              resolvedCasesRender={ref =>
                <Modal
                  ref={ref}
                  heading='Resolved cases'
                  body={
                    <CasesWrapper
                      identityId={identityId}
                      status='resolved'
                      onCaseViewClick={this.handleCaseViewClick}
                    />
                  }
                  elementId={elementId}
                />
              }
              updateData={refetch}
              key={this.state.viewCaseDetailsTimestamp}  // key prop used to reset component when user clicks throught to case from any of the listings (open/resolved)
            />
          )
        }}
      </Query>
    )
  }
}


class CasesWrapper extends React.Component {
  static propTypes = {
    identityId: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    onCaseViewClick: PropTypes.func.isRequired
  }

  state = {
    orderBy: '-created_at'
  }

  toggleSort = () => (
    this.setState(prevState => ({
      orderBy: prevState.orderBy[0] === '-'
        ? 'created_at'
        : '-created_at'
    }))
  )

  render() {
    return (
      <Cases
        status={this.props.status}
        productType=''
        requestType=''
        priority=''
        assignedTo=''
        createdBy=''
        search=''
        reviewed=''
        affects={this.props.identityId}
        showStatusColumn={true}
        resultsPerPage={5}
        condensedView={true}
        orderBy={this.state.orderBy}
        changeSort={this.toggleSort}
        onClick={this.props.onCaseViewClick}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/toolbar-identity-cases/index.js